import format from 'date-fns/format';

import { processSessions } from './processors';

export const SetSessions = (db, currentStore) => async (items, date) => {
  const key = format(date, 'YYYY-MM-DD');

  return Promise.all([
    db.set(currentStore, key, items),
    db.set('updated', `${key}-${currentStore}`, new Date().toJSON()),
  ]);
};

export const GetSessions = (db, currentStore) => async date => {
  try {
    const sessions = await db.get(currentStore, format(date, 'YYYY-MM-DD'));
    return sessions;
  } catch (e) {
    return null;
  }
};
